import * as Api from "api";
import { SIGNIN_PL } from "constants/users";
import { networkAction } from "helpers/network/networkAction";

export const signinPL = (body) => async (dispatch) =>
  networkAction(dispatch, SIGNIN_PL, Api.signinPL, [body]);
